import { render, staticRenderFns } from "./NeedWebSide.vue?vue&type=template&id=52d97b22&"
import script from "./NeedWebSide.vue?vue&type=script&lang=js&"
export * from "./NeedWebSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports